import { analyticsUtils } from 'utils/analytics-utils';

export const seeMoreLinkOnClick = (
  elementBlock: string,
  seeAllButtonCaption: string,
  seeMoreLinkActual: string,
  titleActual?: string,
) => {
  analyticsUtils.sendEvent('GA:clickButton', {
    elementBlock,
    elementType: 'button',
    elementName: titleActual,
    elementText: seeAllButtonCaption,
    elementLink: seeMoreLinkActual,
  });
};
